import {
  AUTHENTICATION_LOGOUT,
  BROKER_VERIFY_PIN_FAILED,
  BROKER_VERIFY_PIN_SUCCESS,
} from 'redux/actions';
import { IAction, IBrokerPhoneCode } from 'interfaces/common';

export const BrokerVerifyPin = (
  state: IBrokerPhoneCode[] = [],
  action: IAction<IBrokerPhoneCode>
) => {
  switch (action.type) {
    case BROKER_VERIFY_PIN_SUCCESS:
      const temp = [...state, action.payload];

      return temp;
    case BROKER_VERIFY_PIN_FAILED:
      return state;
    case AUTHENTICATION_LOGOUT:
      return [];

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/global-reducers/BrokerPhoneCode.ts